import { post } from './api';
import type { Inquiry } from '../types/api';

export interface CreateInquiryRequest {
  name: string;
  email: string;
  client_type: 'individual' | 'student' | 'organization';
  project_description: string;
  service_id?: string;
}

/**
 * Submit a new inquiry
 */
export async function createInquiry(data: CreateInquiryRequest): Promise<Inquiry> {
  return post<Inquiry>('/inquiries', data);
}
